module.exports = __webpack_public_path__ + "static/media/login_background.8b96be13.jpg";